import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// 🚀 Wyłącz console.log w produkcji
// if (import.meta.env.PROD) { // Wyłączone tylko w produkcji
//   console.log = () => {}
//   console.warn = () => {}
//   console.info = () => {}
//   console.debug = () => {}
//   console.error = () => {} // Opcjonalnie - można zostawić error dla ważnych błędów
// }

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
